import { FC, useState } from "react";
import { useFlag } from "@unleash/proxy-client-react";

import { ICard } from "../../../../../api/cards/types";
import { UnleashFlags } from "../../../../../constants";
import { PaymentBlockCHDPModal } from "./PaymentBlockCHDPModal";
import { PaymentBlockPaymentModal } from "./PaymentBlockPaymentModal";
import { PaymentDestinationType } from "../../../../../api/payments/types.ts";

export interface IPaymentBlockModalProps {
  amount: string;
  paymentMethod: ICard;
  clearInput: () => void;
  onCancel: () => void;
  hideModal: () => void;
  blockModalClosing: (state: boolean) => void;
  paymentDestination: PaymentDestinationType;
  resetPaymentDestination: () => void;
}

export const PaymentBlockModal: FC<IPaymentBlockModalProps> = (props) => {
  const {
    amount,
    paymentMethod,
    clearInput,
    onCancel,
    hideModal,
    blockModalClosing,
    paymentDestination,
    resetPaymentDestination,
  } = props;

  const isDebtRepaymentOptionsEnabled = useFlag(UnleashFlags.debtRepaymentOptionsEnabled);

  const [isCHDPApproved, setIsCHDPApproved] = useState<boolean>(false);
  const showCHDPInfo = isDebtRepaymentOptionsEnabled && paymentDestination === "EARLY_REPAYMENT" && !isCHDPApproved;

  if (showCHDPInfo) {
    return (
      <PaymentBlockCHDPModal
        amount={amount}
        approveCHDP={() => { setIsCHDPApproved(true); }}
        onCancel={onCancel}
      />
    );
  }

  return (
    <PaymentBlockPaymentModal
      amount={amount}
      paymentMethod={paymentMethod}
      paymentDestination={paymentDestination}
      resetPaymentDestination={resetPaymentDestination}
      clearInput={clearInput}
      onCancel={onCancel}
      hideModal={hideModal}
      blockModalClosing={blockModalClosing}
    />
  );
};
